"use client";

import { useEffect, useState } from "react";

/** True only after the component has mounted — avoids SSR/client mismatches. */
export function useIsMounted() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted;
}
